import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=2a006690"
import script from "./HorizontalMenu.vue?vue&type=script&lang=ts"
export * from "./HorizontalMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports